module.exports = __webpack_public_path__ + "static/media/left-shield-big.67682f2e.svg";